import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from './api';

// One request per checkout session per tab. React StrictMode runs effects
// twice in dev, so the second run must re-attach to the same request
// instead of skipping it (skipping left the banner stuck on "Confirming").
const requests = new Map();

/**
 * After Stripe sends the buyer back (?checkout=success&session_id=cs_…),
 * ask the gateway to read the session from Stripe and grant access now,
 * then reload the page's data. Doesn't wait for the Stripe webhook.
 * Returns { confirming, failed }.
 */
export default function useConfirmPurchase(reload) {
  const [params, setParams] = useSearchParams();
  const sessionId = params.get('session_id');
  const active = params.get('checkout') === 'success' && !!sessionId && sessionId.startsWith('cs_');
  const [state, setState] = useState({ confirming: active, failed: false });

  useEffect(() => {
    if (!active) { setState({ confirming: false, failed: false }); return undefined; }
    if (!requests.has(sessionId)) {
      requests.set(sessionId, api.confirmPurchase(sessionId).then(() => true, () => false));
    }
    let alive = true;
    requests.get(sessionId).then((ok) => {
      if (!alive) return;
      setState({ confirming: false, failed: !ok });
      if (ok) {
        // Drop session_id so refreshing (or reopening) this page later
        // doesn't confirm again; keep checkout=success for the banner.
        const p = new URLSearchParams(window.location.search);
        p.delete('session_id');
        setParams(p, { replace: true });
        reload?.();
      }
    });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, sessionId]);

  return state;
}
